function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { createResourceId, parseResourceId } from ".";
import { mapObjectMapValues } from "../../utils";
import { createResourceVariantStoredValidator } from "../resources/SWBaseStoredResourceVariant";
/** @public */ /** @internal */ export const rootResourceVariantStoredVersions = {};
/** @internal */ export const rootResourceVariantStoredMigrations = defineMigrations({});
/** @public */ export function isResourceVariantStored(record) {
    if (!record) return false;
    return record.typeName === "resource_variant_stored";
}
/** @public */ export function isResourceVariantStoredId(id) {
    if (!id) return false;
    return id.startsWith("resource_variant_stored:");
}
export const parseResourceVariantStoredId = (id)=>{
    if (!id) return undefined;
    if (!id.startsWith("resource_variant_stored:")) return undefined;
    const parts = id.replace("resource_variant_stored:", "").split(":");
    const variant = parts.pop();
    if (!variant) return undefined;
    const parsedResourceId = parseResourceId("resource:" + parts.join(":"));
    if (!parseResourceId) return undefined;
    return _object_spread_props(_object_spread({}, parsedResourceId), {
        variant
    });
};
export const createResourceVariantStoredIdPrefix = (type)=>`resource_variant_stored:${type}:`;
export function createResourceVariantStoredId({ type, name, organizationId, scope, variant }) {
    const resourceId = createResourceId({
        type,
        name,
        organizationId,
        scope
    });
    return `resource_variant_stored:${resourceId.replace("resource:", "")}:${variant}`;
}
export function isTextResourceVariantStored(record) {
    return record.type === "text";
}
export const castResourceVariantStored = (record)=>{
    return {
        toVariant () {
            var _parseResourceVariantStoredId;
            return (_parseResourceVariantStoredId = parseResourceVariantStoredId(record.id)) === null || _parseResourceVariantStoredId === void 0 ? void 0 : _parseResourceVariantStoredId.variant;
        },
        toResourceId () {
            const parts = record.id.split(":");
            parts.pop();
            return parts.join(":").replace(/^resource_variant_stored:/, "resource:");
        }
    };
};
/** @internal */ export function createResourceVariantStoredRecordType(resource_variants) {
    return createRecordType("resource_variant_stored", {
        migrations: undefined,
        scope: "document",
        validator: T.model("resource_variant_stored", T.union("type", mapObjectMapValues(resource_variants, (type, { props, meta })=>createResourceVariantStoredValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {}
        }));
}
